import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const useLanguagePrefix = () => {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  const currentLang = lang || i18n.language || "es";
  return `/${currentLang}`;
};
